export default "__VITE_ASSET__c90f25fd__"